import accounts from './accounts';
import account from './account';

export default {
  namespaced: true,
  modules: {
    accounts,
    account,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/accounts/index.js